export enum ResolveDisputeStatus {
  InProgress = 'InProgress',
  Payout = 'Payout',
  Refund = 'Refund',
}
